// extracted by mini-css-extract-plugin
export default {"timer":"Timer-module__timer--c22d0"};